import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const eprSubCategoriesApi = createApi({
    reducerPath: "eprSubCategoriesApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["EPRSubCategories"],
    endpoints: (builder) => ({
        // Get All EPR Subcategories
        getEPRSubCategories: builder.query({
            query: () => "/epr-subcategory-fees",
            transformResponse: (response) => response.data || response,
            providesTags: ["EPRSubCategories"],
        }),
        // Get a single EPR Subcategory
        getEPRSubCategoryById: builder.query({
            query: (id) => `/epr-subcategory-fees/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: "EPRSubCategories", id }],
        }),

        // Create a new Packaging Subcategory
        createEPRSubcategory: builder.mutation({
            query: (eprSubCategory) => ({
                url: "/epr-subcategory-fees",
                method: "POST",
                body: eprSubCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["EPRSubCategories"],
        }),

        // Update an existing Packaging Subcategory
        updateEPRSubcategory: builder.mutation({
            query: ({ id, ...eprSubCategory }) => ({
                url: `/epr-subcategory-fees/${id}`,
                method: "PUT",
                body: eprSubCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["EPRSubCategories"],
        }),

        // Delete an existing Packaging Subcategory
        deleteEPRSubcategory: builder.mutation({
            query: (id) => ({
                url: `/epr-subcategory-fees/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["EPRSubCategories"],
        }),
    }),
});

export const {
    useGetEPRSubCategoriesQuery,
    useGetEPRSubCategoryByIdQuery,
    useCreateEPRSubcategoryMutation,
    useUpdateEPRSubcategoryMutation,
    useDeleteEPRSubcategoryMutation,
} = eprSubCategoriesApi;